import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

// Utility function to generate light colors
const generateLightColors = (count) => {
  const colors = [];
  for (let i = 0; i < count; i++) {
    const hue = Math.floor(Math.random() * 360); // Random hue
    const saturation = 70 + Math.random() * 10; // Saturation between 70% and 80%
    const lightness = 80 + Math.random() * 10; // Lightness between 80% and 90%
    colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
  }
  return colors;
};

const PieChartComponent = ({ data, title, customColors }) => {
  // Use customColors if provided, otherwise generate them
  const colors = customColors || generateLightColors(data?.length || 0); 

  return (
    <div style={{ width: "100%", height: "300px", textAlign: "center" }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            dataKey="sessions"
            nameKey="device"
            cx="50%"
            cy="50%"
            outerRadius={100}
            fill="#8884d8"
            // Remove the label property completely to hide slice labels
            label={false}
            labelLine={false}
          >
            {data?.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={colors[index % colors.length]}
              />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PieChartComponent;
